import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DashboardSidebarComponent } from '@features/client-dashboard/components/dashboard-sidebar/dashboard-sidebar.component';
import { IncompleteTripCheckService } from '@features/client-dashboard/services/incomplete-trip-check.service';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-client-dashboard',
    imports: [DashboardSidebarComponent],
    templateUrl: './client-dashboard.component.html',
    styleUrls: ['./client-dashboard.component.css'],
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientDashboardComponent {
    private breakpointObserver = inject(BreakpointObserver);
    private incompleteTripCheckService = inject(IncompleteTripCheckService);

    isMobile = toSignal(
        this.breakpointObserver
            .observe([Breakpoints.HandsetPortrait, Breakpoints.TabletPortrait])
            .pipe(map(result => result.matches)),
        { initialValue: false }
    );
}
